import { DOCUMENT } from '@angular/common';
import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';

@Component({
  selector: 'app-generic-start-form',
  templateUrl: './generic-start-form.component.html',
  styleUrls: ['./generic-start-form.component.scss'],
})
export class GenericStartFormComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() alert: string;
  @Input() buttonTitle: string;
  @Output() buttonRedirectGo = new EventEmitter();
  @Output() buttonRedirectBack = new EventEmitter();
  document: Document;

  constructor(@Inject(DOCUMENT) dom: Document) {
    this.document = dom;
  }

  goForm() {
    this.buttonRedirectGo.emit();
  }
}
